import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { AUTH } from '@/constants/testIds';
import { toast } from 'sonner';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/password-reset/request', {
        email,
        origin_url: window.location.origin,
      });
      setSent(true);
      toast.success('RESET_LINK_DISPATCHED');
    } catch {
      // Backend always returns 200 to avoid enumeration; only network errors reach here
      toast.error('Network error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 px-6">
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#38BDF8] mb-3">
        // PASSPHRASE_RECOVERY
      </div>
      <h1 className="text-3xl font-bold uppercase tracking-tighter mb-8">
        Reset Passphrase<span className="caelix-caret"></span>
      </h1>
      {sent ? (
        <div className="c-card">
          <div className="c-label">STATUS</div>
          <div className="text-lg text-[#38BDF8] mb-4">RESET_LINK_DISPATCHED</div>
          <p className="text-xs text-gray-500 leading-relaxed">
            &gt; If an operator exists with <span className="text-white">{email}</span>, a reset link has been sent.
            <br />&gt; The link expires in 30 minutes.
          </p>
          <div className="mt-4 pt-4 border-t border-[#3F3F46]">
            <Link to="/login" className="c-btn-secondary text-xs">BACK_TO_LOGIN</Link>
          </div>
        </div>
      ) : (
        <form data-testid={AUTH.forgotForm} onSubmit={submit} className="c-card space-y-4">
          <div>
            <label className="c-label" htmlFor="forgot-email">Operator Email</label>
            <input
              id="forgot-email"
              data-testid={AUTH.forgotEmail}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="operator@caelix.io"
              className="c-input"
            />
          </div>
          <button
            data-testid={AUTH.forgotSubmit}
            type="submit"
            disabled={busy}
            className="c-btn-primary w-full"
          >
            {busy ? 'DISPATCHING…' : 'DISPATCH_RESET_LINK'}
          </button>
          <div className="text-xs text-gray-500 pt-2 border-t border-[#3F3F46]">
            Remembered it?{' '}
            <Link to="/login" className="text-[#38BDF8] hover:underline uppercase tracking-widest">
              INITIATE_SESSION
            </Link>
          </div>
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordPage;
